import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../../config/withDirection';

const StyleWrapper = styled.div`
    flex-grow: 1;
    margin-right: 14px;

    .app-info { display: flex; justify-content: flex-start; }
    .app-info .app-icon-container { margin-right: 25px; min-width: 80px; width: 80px; height: 80px; }
    .app-info .app-icon-container img { width: 100%; border-radius: 20px; }

    .app-description { display: flex; flex-direction: column; justify-content: space-evenly; }
    .app-description .app-name {
        font-family: 'Montserrat';
        font-size: 22px;
        font-weight: 300;
        color: rgba(64, 55, 57, 1);
        text-align: left;
        letter-spacing: 0.09em;
        text-transform: uppercase;
    }

    .app-stores {
        display: flex;
        align-items: center; 
        font-family: 'Roboto';
        font-size: 14px;
        color: rgba(147, 147, 147, 1);
        text-align: justify;
        letter-spacing: 0.04em;
    }
    .app-stores .stores { margin-left: 14px; }
    .app-stores .stores img:not(:first-child) { margin-left: 7px; }
    .app-stores .stores img { width: 24px; height: 18px; }

    @media screen and (max-width: 767px) {
        margin-bottom: 30px;

        .app-info .app-icon-container { margin-right: 11px; min-width: 70px; width: 70px; height: 70px; }

        .app-description .app-name { line-height: 1; }

        .app-stores { flex-wrap: wrap; }
        .app-stores .stores { flex-grow: 1; margin-left: 0; }
        .app-stores .stores img:not(:only-child) { margin-right: 7px; margin-left: 0;}
    }
`;

export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/OrderSuccess/AppInfo/Wrapper.js